import React from "react";
import styled from "styled-components/macro";
import { Button } from "@mui/material";
import { Trans } from "react-i18next";
import { useViewerQuery, useViewerDecks } from "queries/viewerQuery";
import { useSetState } from "components/ReduxProvider";
import { sourceQuery$data } from "queries/sources/__generated__/sourceQuery.graphql";

const ButtWrap = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  padding: 15px 0 25px;
  width: 100%;
  background: linear-gradient(#f3f9ff00, #f3f9ffaa 30%, #f3f9ffff 95%);
  z-index: 5;
`;

const SButton = styled(Button)`
  width: 70%;
  max-width: 400px;
`;

type Props = {
  source: NonNullable<sourceQuery$data["sourceByUriOrId"]>;
  onSetShowPicker: VoidFunction;
};

const SetCardsPickButton: React.FC<Props> = ({ source, onSetShowPicker }) => {
  const { viewer } = useViewerQuery();
  const { decks } = useViewerDecks();
  const setDeckCreate = useSetState("deckCreate");

  if (!viewer) return null;

  const handleClick = () => {
    const hasDeckForLanguage = decks?.find((d) => d.front === source.lang);
    if (hasDeckForLanguage) {
      onSetShowPicker();
    } else {
      setDeckCreate({ lang: source.lang });
    }
  };

  return (
    <ButtWrap>
      <SButton variant="contained" size="large" onClick={handleClick}>
        <Trans>Pick cards</Trans>
      </SButton>
    </ButtWrap>
  );
};

export default SetCardsPickButton;
